import checkoutAddNewAddressModalHtml from './../checkout/checkoutaddnewaddress.modal.html';

class DownloadOffer {
    constructor($scope, $http, $q, CheckoutService, ModalService, translateService, SnackbarService, hide, shipmentId, threadId) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$q = $q;
        this.CheckoutService = CheckoutService;
        this.ModalService = ModalService;
        this.translate = translateService;
        this.SnackbarService = SnackbarService;

        this.hideCallback = hide;

        this.shipment_id = shipmentId;
        this.thread_id = threadId;

        this.valuationId = null;
        this.valuationVariantId = null;

        this.loading = false;
        this.sendingOffer = false;

        this.userInvoiceAddresses = [];

        this.showLoggedFormAllErrors = false;
        this.logged_data = {
            invoiceAddressId: null
        };

        this.client_data = null;

        this.init();
    }

    init() {
        this.loading = true;

        this.$http.get('/ajax/checkout/get-invoice-addresses')
            .then((response) => {
                if (response.data.message && response.data.message.type !== 'success') {
                    this.SnackbarService.add(response.data.message.content, 'error', true, 3000);

                    return;
                }
    
                this.userInvoiceAddresses = response.data.data.addresses;

                if (this.userInvoiceAddresses.length === 1) {
                    this.logged_data.invoiceAddressId = this.userInvoiceAddresses[0].id
                }

                return response.data.data;
            })
            .catch(() => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    get getExpirationDate() {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 14);
        const options = { month: '2-digit', day: '2-digit', year: 'numeric' };

        return expirationDate.toLocaleDateString('pl-PL', options).replace(/\./g, '.');
    }

    // Poprawnie wypełniony formularz użytkownika zalogowanego?
    get loggedIsValid() {
        if (this.logged_data.invoiceAddressId) {
            return true;
        }

        return false;
    }

    // Czy można pobrać przez użytkownika zalogowanego?
    get canDownloadLogged() {
        if (this.loggedIsValid) {
            return true
        }

        return false;
    }

    get userInvoiceAddressString() {
        const address = this.userInvoiceAddresses.find(x => parseInt(x.id) === parseInt(this.logged_data.invoiceAddressId));

        let addressString = '';

        if (address.company === '' && address.tax_id === '') {
            addressString = addressString + address.first_name + ' ' + address.last_name;
        } else {
            addressString = addressString + (address.first_name !== '' && address.last_name !== '' ? address.first_name + ' ' + address.last_name + '|' : '') + address.company;
        }

        addressString = addressString + '|' + address.address;

        addressString = addressString + '|' + address.zip + ' ' + address.city;

        return addressString;
    }

    setUserInvoiceAddress(address) {
        this.logged_data.invoiceAddressId = address.id;
    }

    editUserInvoiceAddress(address) {
        const shopCountry = this.CheckoutService.shopCountry;

        let _this = this;

        this.ModalService.showModal({
            template: checkoutAddNewAddressModalHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 0;
                    this.title = _this.translate.t('checkout.editInvoiceAddress');
                    this.address = address;
                    this.closeCallback = close;
                    this.shopCountry = shopCountry;
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');

                $('body').addClass('modal-open');
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(modifiedAddress => {
                if (!modifiedAddress) return;
    
                modifiedAddress = this.CheckoutService.transformAddress(modifiedAddress.data, true);
                for (const [prop, value] of Object.entries(address)) {
                    address[prop] = modifiedAddress[prop];
                }
            });
        });
    }

    addNewUserInvoiceAddress() {
        const shopCountry = this.CheckoutService.shopCountry;

        let _this = this;

        this.ModalService.showModal({
            template: checkoutAddNewAddressModalHtml,
            controller: class {
                constructor($scope, close) {
                    'ngInject';

                    this.type = 0;
                    this.title = _this.translate.t('checkout.newInvoiceAddress');
                    this.closeCallback = close;
                    this.shopCountry = shopCountry;
                }

                close(data) {
                    this.closeCallback(data);
                }
            },
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');

                $('body').addClass('modal-open');
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(address => {
                if (!address) return;

                const newAddress = {
                    id: address.id,
                    name: address.data.addressName,
                    first_name: address.data.firstName,
                    last_name: address.data.lastName,
                    company: address.data.companyName,
                    tax_id: address.data.taxNumber,
                    ico_id: address.data.icoNumber,
                    country: address.data.country,
                    zip: address.data.zipCode,
                    city: address.data.city,
                    address: address.data.address,
                    type: 0,
                    default: 0
                }

                this.userInvoiceAddresses.push(newAddress);
                this.setUserInvoiceAddress(newAddress);
            });
        });
    }

    createOffer() {
        let data = {};

        if (this.canDownloadLogged) {
            this.showLoggedFormAllErrors = true;

            this.logged_form.$$setSubmitted();
    
            if (!this.loggedIsValid) {
                return;
            }
    
            data = {
                email: null,
                client_data: this.userInvoiceAddressString,
                client_logged: 1,
                shipment_id: this.shipment_id,
                thread_id: this.thread_id
            };
    
            this.client_data = data.client_data;
        } else {
            return;
        }

        this.loading = true;

        return this.$http.post('/user/configurator/manual/ajax/createValuation', data)
            .then((response) => {
                if (response.data.message && response.data.message.type !== 'success') {
                    this.SnackbarService.add(response.data.message.content, 'error', true, 3000);

                    return;
                }

                this.valuationId = response.data.data.valuation_id;
                this.valuationVariantId = response.data.data.valuation_variant_id;
                this.valuationNumber = response.data.data.valuation_number;

                return response.data.data;
            })
            .catch(() => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    downloadOffer() {
        if (this.valuationId === null) {
            return;
        }

        const url = `/configurator/valuations/pdf/${this.valuationId}/${btoa(unescape(encodeURIComponent(this.client_data)))}`;

        window.open(url, '_blank');
    
        this.hide();
    }

    sendOffer() {
        this.sendingOffer = true;

        return this.$http.post('/ajax/checkout/send-valuation', {valuationId: this.valuationId, clientData: btoa(unescape(encodeURIComponent(this.client_data)))})
            .then((response) => {
                this.SnackbarService.add(response.data.message.content, response.data.message.type, true, 3000);

                return;
            })
            .catch(() => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
                this.sendingOffer = false;
            })
            .finally(() => {
                this.loading = false;
                this.sendingOffer = false;

                this.hide();
            });
    }

    // Ukryj modal bez usuwania instancji ng
    hide() {
        this.hideCallback();
    }
}

export default DownloadOffer;
